/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

// Floating cookie preferences button
function addCookieButton() {
  if (window.Shopify && window.Shopify.customerPrivacy) {
    var btn = document.createElement('button');
    btn.innerHTML = '🍪';
    btn.setAttribute('aria-label', 'Cookie preferences');
    btn.style.cssText = 'position:fixed;bottom:20px;left:20px;z-index:9999;background:#fff;border:1px solid #ccc;border-radius:50%;width:44px;height:44px;font-size:22px;cursor:pointer;box-shadow:0 2px 8px rgba(0,0,0,0.2);';
    btn.addEventListener('click', function() {
      window.Shopify.customerPrivacy.loadBanner();
    });
    document.body.appendChild(btn);
  }
}

document.addEventListener('DOMContentLoaded', function() {
  // Czekamy aż Shopify Customer Privacy API się załaduje
  if (window.Shopify && window.Shopify.customerPrivacy) {
    addCookieButton();
  } else {
    window.addEventListener('shopify:consent:ready', addCookieButton);
    // Fallback z opóźnieniem
    setTimeout(addCookieButton, 2000);
  }
});

// Hide cookie banner decline button
var style = document.createElement('style');
style.textContent = '#shopify-pc__banner__btn-decline { display: none !important; }';
document.head.appendChild(style);
